import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import './Deposit.css'; // Custom CSS for additional styling


const Deposit = () => {
    const [amount, setAmount] = useState(0);
    const [banks, setBanks] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState({
        qr1: '', qr2: '', upi1: '', upi2: ''
    });
    const [depositHistory, setDepositHistory] = useState([]);
    const [activeTab, setActiveTab] = useState('qr');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [copiedUpi, setCopiedUpi] = useState(null);

    useEffect(() => {
    const fetchData = async () => {
        try {
            const userId = localStorage.getItem('userid');
            
            // Fetch all data
            const banksResponse = await axios.get('https://gtfundcrop.com/Rest5/banks_api');
            const paymentMethodsResponse = await axios.get('https://gtfundcrop.com/Rest5/company_profile_api');
            const depositHistoryResponse = await axios.get(`https://gtfundcrop.com/Rest5/deposite_api/${userId}`);
            
            // Update state
            setBanks(banksResponse.data);
            setPaymentMethods(paymentMethodsResponse.data);
            setDepositHistory(depositHistoryResponse.data);
            
        } catch (error) {
            console.error("Error fetching data:", error);
            // Optionally show error to user
        }
    };

    fetchData();
}, []);

    const handleAmountPreset = (presetAmount) => {
        setAmount(presetAmount);
    };

    const copyToClipboard = (upiId) => {
        navigator.clipboard.writeText(upiId);
        setCopiedUpi(upiId);
        setTimeout(() => setCopiedUpi(null), 2000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (amount <= 0) {
            alert("Please enter a valid amount");
            return;
        }

        setIsSubmitting(true);
        try {
            const formData = new FormData();
            formData.append("dep_amt", amount);
            formData.append("dremark", 'NA');
            formData.append("user", localStorage.getItem('userid'));

            const response = await axios.post(
                'https://gtfundcrop.com/Rest5/web_deposite_submit_api', 
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                }
            );
            
            alert("Deposit request submitted successfully!");
            console.log(response.data.msg);
        } catch (error) {
            console.error("Deposit submission error:", error);
            alert("Failed to submit deposit request");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="deposit-page">
            <Helmet>
                <title>Deposit Funds | MCX Trading</title>
            </Helmet>

            {/* Header */}
            <header className="deposit-header">
                <Link to="/dashboard" className="back-button">
                    <i className="fa fa-arrow-left"></i>
                </Link>
                <h1>Deposit Funds</h1>
                <div className="header-spacer"></div>
            </header>

            <main className="deposit-content">
                {/* Payment Method Tabs */}
                <div className="payment-method-tabs">
                    <button 
                        className={`tab-btn ${activeTab === 'qr' ? 'active' : ''}`}
                        onClick={() => setActiveTab('qr')}
                    >
                        <i className="fa fa-qrcode"></i> QR Code
                    </button>
                    <button 
                        className={`tab-btn ${activeTab === 'upi' ? 'active' : ''}`}
                        onClick={() => setActiveTab('upi')}
                    >
                        <i className="fa fa-mobile-alt"></i> UPI
                    </button>
                    <button 
                        className={`tab-btn ${activeTab === 'bank' ? 'active' : ''}`}
                        onClick={() => setActiveTab('bank')}
                    >
                        <i className="fa fa-university"></i> Bank Transfer
                    </button>
                </div>

                {/* QR Code Payment */}
                {activeTab === 'qr' && (
                    <div className="payment-section">
                        <div className="qr-codes">
                            {paymentMethods.qr1 && (
                                <div className="qr-code-container">
                                    <h3>UPI QR Code 1</h3>
                                    <img 
                                        src={'https://gtfundcrop.com/assets/images/'+paymentMethods.qr1} 
                                        alt="UPI QR Code 1" 
                                        className="qr-code"
                                    />
                                </div>
                            )}
                            {paymentMethods.qr2 && (
                                <div className="qr-code-container">
                                    <h3>UPI QR Code 2</h3>
<img 
                                        src={'https://gtfundcrop.com/assets/images/'+paymentMethods.qr2} 
                                        alt="UPI QR Code 1" 
                                        className="qr-code"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="amount-section">
                            <h3>Enter Deposit Amount</h3>
                            <div className="amount-presets">
                                <button 
                                    className="preset-btn"
                                    onClick={() => handleAmountPreset(1000)}
                                >
                                    ₹1,000
                                </button>
                                <button 
                                    className="preset-btn"
                                    onClick={() => handleAmountPreset(5000)}
                                >
                                    ₹5,000
                                </button>
                                <button 
                                    className="preset-btn"
                                    onClick={() => handleAmountPreset(10000)}
                                >
                                    ₹10,000
                                </button>
                            </div>
                            
                            <div className="amount-input">
                                <span className="currency-symbol">₹</span>
                                <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    placeholder="Enter custom amount"
                                    min="100"
                                    step="100"
                                />
                            </div>
                            
                            <button 
                                className="submit-btn"
                                onClick={handleSubmit}
                                disabled={isSubmitting || amount <= 0}
                            >
                                {isSubmitting ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin"></i> Processing...
                                    </>
                                ) : (
                                    "Submit Deposit Request"
                                )}
                            </button>
                        </div>
                    </div>
                )}

                {/* UPI Payment */}
                {activeTab === 'upi' && (
                    <div className="payment-section">
                        <div className="upi-methods">
                            <h3>UPI Payment Details</h3>
                            {paymentMethods.upi1 && (
                                <div className="upi-id-container">
                                    <div className="upi-id">
                                        <span>{paymentMethods.upi1}</span>
                                        <button 
                                            className="copy-btn"
                                            onClick={() => copyToClipboard(paymentMethods.upi1)}
                                        >
                                            {copiedUpi === paymentMethods.upi1 ? (
                                                <><i className="fa fa-check"></i> Copied!</>
                                            ) : (
                                                <><i className="fa fa-copy"></i> Copy</>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {paymentMethods.upi2 && (
                                <div className="upi-id-container">
                                    <div className="upi-id">
                                        <span>{paymentMethods.upi2}</span>
                                        <button 
                                            className="copy-btn"
                                            onClick={() => copyToClipboard(paymentMethods.upi2)}
                                        >
                                            {copiedUpi === paymentMethods.upi2 ? (
                                                <><i className="fa fa-check"></i> Copied!</>
                                            ) : (
                                                <><i className="fa fa-copy"></i> Copy</>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Bank Transfer */}
                {activeTab === 'bank' && (
                    <div className="payment-section">
                        <div className="bank-details">
                            <h3>Bank Transfer Details</h3>
                            <div className="bank-cards">
                                {banks.map((bank, index) => (
                                    <div className="bank-card" key={index}>
                                        <div className="bank-header">
                                            <i className="fa fa-university"></i>
                                            <h4>{bank.bank_name}</h4>
                                        </div>
                                        <div className="bank-details-list">
                                            <div className="detail-item">
                                                <span>Account Name</span>
                                                <span>{bank.acc_name}</span>
                                            </div>
                                            <div className="detail-item">
                                                <span>Account Number</span>
                                                <span>{bank.acc_number}</span>
                                            </div>
                                            <div className="detail-item">
                                                <span>IFSC Code</span>
                                                <span>{bank.ifsc_code}</span>
                                            </div>
                                            <div className="detail-item">
                                                <span>Branch</span>
                                                <span>{bank.branch || 'N/A'}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Recent Deposits Section */}
                <div className="recent-deposits">
                    <h3>Recent Deposit History</h3>
                    {depositHistory.length > 0 ? (
                        <div className="deposit-history">
                            {depositHistory.map((deposit, index) => (
                                <div className="deposit-item" key={index}>
                                    <div className="deposit-info">
                                        <span className="deposit-amount">₹{deposit.dep_amt}</span>
                                        <span className="deposit-date">{deposit.dep_submit_date}</span>
                                    </div>
                                    <div className={`deposit-status ${deposit.dep_status.toLowerCase()}`}>
                                        {deposit.dep_status}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="empty-state">
                            <i className="fa fa-wallet"></i>
                            <p>No deposit history found</p>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default Deposit;